// src/components/editors/ButtonStyler.js
import React from 'react';
import ToggleGroup from '../common/ToggleGroup';

/**
 * ButtonStyler - Reusable button style configurator
 *
 * @param {object} buttonStyle - Current button style object
 * @param {function} onChange - Callback when style changes
 * @param {string} previewColor - Color for preview button
 */
const ButtonStyler = ({
  buttonStyle,
  onChange,
  previewColor = '#7C3AED'
}) => {
  const radiusOptions = [
    { value: 'sharp', label: 'Sharp', borderRadius: '0px' },
    { value: 'rounded', label: 'Rounded', borderRadius: '8px' },
    { value: 'very-rounded', label: 'Pill', borderRadius: '9999px' }
  ];

  const sizeOptions = [
    { value: 'compact', label: 'Compact', padding: '6px 16px', fontSize: '13px' },
    { value: 'medium', label: 'Medium', padding: '10px 24px', fontSize: '14px' },
    { value: 'large', label: 'Large', padding: '14px 32px', fontSize: '16px' }
  ];

  const handleRadiusChange = (radiusId) => {
    onChange({
      ...buttonStyle,
      cornerRadius: radiusId
    });
  };

  const handleSizeChange = (sizeId) => {
    onChange({
      ...buttonStyle,
      size: sizeId
    });
  };

  // Get preview styles
  const getPreviewStyles = () => {
    const radius = radiusOptions.find(r => r.value === buttonStyle.cornerRadius) || radiusOptions[1];
    const size = sizeOptions.find(s => s.value === buttonStyle.size) || sizeOptions[1];
    return {
      borderRadius: radius.borderRadius,
      padding: size.padding,
      fontSize: size.fontSize
    };
  };

  return (
    <div className="space-y-5">
      {/* Border Radius */}
      <div>
        <label className="block text-sm font-medium text-gray-700 mb-2">
          Button Corners
        </label>
        <ToggleGroup
          options={radiusOptions}
          value={buttonStyle.cornerRadius}
          onChange={handleRadiusChange}
        />
      </div>

      {/* Size */}
      <div>
        <label className="block text-sm font-medium text-gray-700 mb-2">
          Button Size
        </label>
        <ToggleGroup
          options={sizeOptions}
          value={buttonStyle.size}
          onChange={handleSizeChange}
        />
      </div>

      {/* Preview */}
      <div>
        <label className="block text-sm font-medium text-gray-700 mb-2">
          Preview
        </label>
        <div className="p-6 bg-gray-50 rounded-lg border border-gray-200 flex items-center justify-center">
          <button
            type="button"
            className="font-medium transition-all"
            style={{
              backgroundColor: previewColor,
              color: 'white',
              ...getPreviewStyles()
            }}
          >
            Book a Session
          </button>
        </div>
      </div>
    </div>
  );
};

export default ButtonStyler;
